import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { DiveSitesByTripQuery } from '../gql/graphql';

// Define the GraphQL query for fetching dive sites
const diveSitesByTripQuery = graphql(/* GraphQL */ `
  query diveSitesByTrip($tripId: Int!) {
    diveSites(tripId: $tripId) {
      diveSiteId
      siteName
    }
  }
`);

// Custom hook for fetching dive sites based on tripId
const useDiveSites = (tripId: number, shouldFetch?: boolean) => {
  const { data, isLoading, error } = useQuery<DiveSitesByTripQuery>({
    queryKey: ['diveSites', tripId],
    queryFn: async () =>
      graphqlRequest<DiveSitesByTripQuery>(diveSitesByTripQuery, { tripId }), // Public endpoint, no auth needed
    enabled: !!shouldFetch,
    staleTime: 3600000, // 1 hour
    retry: shouldRetryQuery,
  });

  return {
    diveSites: data?.diveSites || [],
    isLoading,
    error,
  };
};

export default useDiveSites;
